import {
  Box,
  Button,
  Checkbox,
  FileInput,
  Grid,
  Group,
  LoadingOverlay,
  Modal,
  Select,
  Text,
  TextInput,
  rem,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCheck,
  IconCircleMinus,
  IconCirclePlus,
  IconFileCv,
  IconMinus,
  IconPlus,
  IconRotateClockwise,
} from "@tabler/icons-react";
import moment from "moment";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import { formatFormData } from "../../../_base/helper/FunctionHelper";
import Repository from "../../../_base/helper/HttpHelper";
import { modifyArticleList } from "../../../api/ApiArticle";
import { uploadFile } from "../../../api/ApiProduct";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";
import { convertImageDomain } from "../../../const/converhandle";
import { ArticleList } from "../../../model/Article";
import { MessageResponse } from "../../../model/MessageResponse";
import { repositoryWeb } from "../../../_base/_const/_constVar";

interface CategoryList {
  catid: number;
}

const EditView = ({ id, onSuccess }: any) => {
  const entity = {
    type: "",
    title: "",
    videoCode: "",
    externalUrl: "",
    url: "",
    requestPath: "",
    urlHash: "",
    thumnail: "",
    imageBackground: "",
    extend: "",
    summary: "",
    tags: "",
    creationDate: "",
    createdBy: "",
    lastUpdateDate: "",
    lastUpdatedBy: "",
    ordering: "",
    reviewRate: "",
    reviewCount: "",
    status: "",
    visit: "",
    likeCount: "",
    isFeatured: "",
    approvedStatus: "",
    metaTitle: "",
    metaKeywords: "",
    metaDescription: "",
    commentCount: "",
    commentRate: "",
    postedDate: "",
    isStricking: "",
    content: "",
    imagePath: "",
    imageDetailPath: "",
    allowSeIndex: "",
    attribute1: "",
    attribute2: "",
    attribute3: "",
    attribute4: "",
    attribute5: "",
    attribute6: "",
    attribute7: "",
    attribute8: "",
    attribute9: "",
    attribute10: "",
    tblArticleImageCommands: [],
  };

  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [valueDescription, setValueDescription] = useState(null);
  const [dataArcticleCategory, setDataArcticleCategory] = useState<any>();
  const [selectedItems, setSelectedItems] = useState<CategoryList[]>([]);
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());
  const icon = (
    <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );
  const [timeOption, setTimeOption] = useState("");
  const [modalImageUrl, setModalImageUrl] = useState<string | null>(null);
  const [modalOpened, setModalOpened] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);

  const handleChangeDataContent = (content: string | null) => {
    let modifiedString = content?.replace(
      /src="\/media/g,
      'src="https://hanoicomputercdn.com/media'
    );
    return modifiedString ? modifiedString : "";
  };

  const handleCreateArticleList = async (dataSubmit: ArticleList) => {
    if (!dataSubmit.title || dataSubmit.title.length === 0) {
      NotificationExtension.Fails("Vui lòng nhập tiêu đề bài viết !");
      return;
    } else if (!dataSubmit.thumnail || dataSubmit.thumnail.length === 0) {
      NotificationExtension.Fails("Vui lòng chọn ảnh cho bài viết !");
      return;
    } else {
      open();
      if (timeOption === "now") {
        dataSubmit.postedDate = moment().format("YYYY-MM-DD[T]HH:mm:ss");
      }

      // Loại bỏ thumnail và imageBackground khỏi dataSubmit vì sẽ gửi file thật qua FormData
      const { content, ...restData } = form.getValues();

      // Đồng bộ requestPath và url mà không tự sinh từ tiêu đề
      let url = restData.url || "";
      let requestPath = restData.requestPath || "";

      if (url) {
        // Người dùng nhập URL thủ công -> chuẩn hóa và gán requestPath tương ứng
        restData.url = url.replace(/^\//, "");
        restData.requestPath = url.startsWith("/") ? url : `/${url}`;
      } else if (requestPath) {
        // Trường hợp chỉ có requestPath
        restData.requestPath = requestPath.startsWith("/")
          ? requestPath
          : `/${requestPath}`;
        restData.url = restData.requestPath.replace(/^\//, "");
      }

      // Tạo FormData để gửi file binary giống EditView
      const formData = new FormData();

      // Xử lý từng field một cách rõ ràng
      Object.keys(restData).forEach((key) => {
        const value = (restData as any)[key];

        if (value !== null && value !== undefined) {
          if (Array.isArray(value)) {
            // Xử lý array - gửi từng phần tử với index
            value.forEach((item, index) => {
              if (item !== null && item !== undefined) {
                formData.append(`${key}[${index}]`, item.toString());
              }
            });
            console.log(`Array ${key}:`, value); // Debug array
          } else if (typeof value === "object" && !(value instanceof File)) {
            // Xử lý object phức tạp
            formatFormData(value, formData, key);
          } else {
            // Xử lý giá trị đơn giản
            formData.append(key, value.toString());
          }
        }
      });

      // Thêm nội dung đã xử lý
      formData.append("content", handleChangeDataContent(valueDescription));

      // Debug: Kiểm tra dữ liệu FormData
      console.log("FormData được chuẩn bị để gửi:", restData);
      console.log(
        "Content được thêm:",
        handleChangeDataContent(valueDescription)
      );

      try {
        const res = await repositoryWeb.post(`/TblArticlePos/edit`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (res && res.success) {
          NotificationExtension.Success("Chỉnh sửa bài viết thành công !");
          onSuccess();
          modals.closeAll();
        } else {
          NotificationExtension.Fails(res.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        close();
      }
    }
  };

  const form = useForm<any>({
    initialValues: {
      ...entity,
    },
    validate: {},
  });

  // Hàm để toggle expand/collapse danh mục
  const toggleExpanded = (itemId: number) => {
    setExpandedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  };

  // Hàm đệ quy để render cây danh mục
  const renderCategoryTree = (categories: any[], level: number = 0) => {
    return categories.map((item: any) => {
      const hasChildren =
        item.tblArticleCategoryModels &&
        item.tblArticleCategoryModels.length > 0;
      const isExpanded = expandedItems.has(item.id);

      return (
        <Box key={item.id}>
          {/* Render checkbox cho danh mục hiện tại */}
          <Group
            gap="xs"
            wrap="nowrap"
            style={{ marginLeft: `${level * 20}px` }}
          >
            {/* Icon expand/collapse chỉ hiện khi có danh mục con */}
            {hasChildren ? (
              <Box
                style={{
                  cursor: "pointer",
                  minWidth: "20px",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => toggleExpanded(item.id)}
              >
                {isExpanded ? (
                  <IconCircleMinus size={20} color="#1976d2" />
                ) : (
                  <IconCirclePlus size={20} color="#1976d2" />
                )}
              </Box>
            ) : (
              <Box style={{ minWidth: "20px" }} />
            )}

            {/* Checkbox */}
            <Checkbox
              style={{
                paddingTop: "4px",
                paddingBottom: "4px",
                fontWeight: "normal",
              }}
              label={item.name}
              checked={selectedItems.some(
                (selectedItem) => selectedItem.catid === item.id
              )}
              onChange={() => handleCheckboxChange(item.id)}
            />
          </Group>

          {/* Render danh mục con (đệ quy) - chỉ hiện khi expanded */}
          {hasChildren &&
            isExpanded &&
            renderCategoryTree(item.tblArticleCategoryModels, level + 1)}
        </Box>
      );
    });
  };

  const handleCheckboxChange = (catid: number) => {
    setSelectedItems((prevItems) => {
      const itemIndex = prevItems.findIndex((item) => item.catid === catid);
      if (itemIndex !== -1) {
        const newSelectedItems = [...prevItems];
        newSelectedItems.splice(itemIndex, 1);
        const newArray = newSelectedItems.map((item) => item.catid);
        form.setValues({ listCategoryId: newArray });
        return newSelectedItems;
      } else {
        const newArray = [...prevItems, { catid }];
        form.setValues({ listCategoryId: newArray.map((item) => item.catid) });
        return newArray;
      }
    });
  };

  const handleChangeStatus = (id: string | null) => {
    if (id !== null) {
      form.getInputProps("status").onChange(Number(id));
    } else {
      form.getInputProps("status").onChange(null);
    }
  };

  useEffect(() => {
    const callApiGetData = async () => {
      open();
      try {
        // Fetch dữ liệu detail và category cùng lúc
        const [detailResponse, categoryResponse] = await Promise.all([
          repositoryWeb.get<MessageResponse<ArticleList>>(
            `/TblArticlePos/get-detail/${id}`
          ),
          repositoryWeb.get(`/TblArticlePos/get-create`), // Fetch category data
        ]);

        // Xử lý category data trước
        if (categoryResponse && categoryResponse.success) {
          setDataArcticleCategory(categoryResponse.data);
        }

        // Xử lý detail data
        if (
          !isNullOrUndefined(detailResponse) &&
          !isNullOrUndefined(detailResponse?.data)
        ) {
          const dataApi = detailResponse?.data;
          if (dataApi != null && !isNullOrUndefined(dataApi)) {
            form.setValues(dataApi);

            // Xử lý selected categories
            if (
              dataApi.tblArticleCategoryDetModels &&
              Array.isArray(dataApi.tblArticleCategoryDetModels)
            ) {
              const catIdObjects = dataApi.tblArticleCategoryDetModels
                .map((item: any) => ({ catid: item.catId } as CategoryList))
                .filter((catIdObj) => catIdObj.catid !== undefined);
              setSelectedItems(catIdObjects);
              form.setValues({
                listCategoryId: catIdObjects.map((item) => item.catid),
              });
            }

            // Xử lý timeOption dựa trên dữ liệu
            if (dataApi.postedDate) {
              setTimeOption("custom");
            } else {
              setTimeOption("now");
            }
          } else {
            NotificationExtension.Fails("Dữ liệu không tồn tại");
            modals.closeAll();
          }
        } else {
          NotificationExtension.Fails("Dữ liệu không tồn tại");
          modals.closeAll();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        NotificationExtension.Fails("Có lỗi xảy ra khi tải dữ liệu");
        modals.closeAll();
      } finally {
        close();
      }
    };

    if (id || id === 0) {
      callApiGetData();
    }
  }, [id]);

  const handleImgUrlChange = async (file: File | null) => {
    if (file) {
      const result = await uploadFile([file], "article");
      if (result && result.success && result.data && result.data[0]?.url) {
        form.setFieldValue("thumnail", result.data[0].url);
      } else {
        NotificationExtension.Fails("Tải ảnh lên thất bại!");
      }
    }
  };

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={1300}
        maw={1500}
        mx="auto"
        onSubmit={form.onSubmit((e: ArticleList) => {
          handleCreateArticleList(e);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <>
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <TextInput
                label={"Tiêu đề"}
                placeholder={"Nhập tiêu đề"}
                withAsterisk
                mt="md"
                type="text"
                {...form.getInputProps("title")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Box style={{ display: "flex", flex: 1, gap: "1rem" }}>
                <Select
                  label="Thời gian của bài viết"
                  placeholder="Thay đổi thời gian"
                  data={[
                    { value: "now", label: "Thời gian tạo bài" },
                    { value: "custom", label: "Chọn thời gian" },
                  ]}
                  value={timeOption}
                  onChange={(val) => setTimeOption(val || "")}
                  mt="md"
                  style={{
                    flex: 1,
                  }}
                  clearable
                  // styles={{
                  //   input: {
                  //     color: "#000",
                  //     fontWeight: 400,
                  //   },
                  // }}
                />
                {timeOption === "custom" && (
                  <DateTimePicker
                    {...form.getInputProps("postedDate")}
                    value={
                      form.values.postedDate
                        ? new Date(form.values.postedDate)
                        : null
                    }
                    onChange={(value: any) =>
                      form.setFieldValue(
                        "postedDate",
                        moment(value).format("YYYY-MM-DD[T]HH:mm:ss")
                      )
                    }
                    locale="vi"
                    withAsterisk
                    mt="md"
                    label="Thời gian đăng tải"
                    placeholder="Thời gian đăng tải"
                    style={{
                      flex: 1,
                    }}
                  />
                )}
                {timeOption === "now" && (
                  <DateTimePicker
                    {...form.getInputProps("creationDate")}
                    value={
                      form.values.creationDate
                        ? new Date(form.values.creationDate)
                        : null
                    }
                    locale="vi"
                    mt="md"
                    label="Thời gian đăng tải"
                    minDate={new Date()}
                    placeholder="Thời gian đăng tải"
                    readOnly
                    style={{
                      flex: 1,
                    }}
                  />
                )}
                {timeOption !== "now" && timeOption !== "custom" && (
                  <DateTimePicker
                    value={
                      form.values.postedDate
                        ? new Date(form.values.postedDate)
                        : null
                    }
                    locale="vi"
                    mt="md"
                    label="Thời gian ban đầu"
                    minDate={new Date()}
                    readOnly
                    style={{
                      flex: 1,
                    }}
                  />
                )}
              </Box>
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, md: 4 }}>
              <Select
                label={"Trạng thái"}
                placeholder={"Trạng thái"}
                // withAsterisk
                data={[
                  { value: "0", label: "Chờ duyệt" },
                  { value: "1", label: "Cho hiển thị" },
                  { value: "2", label: "Bản nháp" },
                ]}
                value={
                  form.values.status !== null &&
                  form.values.status !== undefined
                    ? form.values.status.toString()
                    : null
                }
                onChange={(e) => handleChangeStatus(e)}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 4 }}>
              <TextInput
                label={"Thứ tự"}
                placeholder={"Nhập thứ tự"}
                // withAsterisk
                type="number"
                {...form.getInputProps("ordering")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 4 }}>
              <Select
                label={"Nổi bật"}
                placeholder={"Nhập nổi bật"}
                withAsterisk
                data={[
                  { value: "Y", label: "Nổi bật" },
                  { value: "N", label: "Không nổi bật" },
                ]}
                {...form.getInputProps("isStricking")}
                clearable
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={12}>
              <TextInput
                label={"Url"}
                placeholder={"Nhập url"}
                type="text"
                {...form.getInputProps("url")}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={12}>
              <Box>
                <FileInput
                  leftSection={icon}
                  label={"Hình thu nhỏ"}
                  placeholder={"Nhập hình thu nhỏ"}
                  accept="image/*"
                  leftSectionPointerEvents="none"
                  clearable
                  mt="md"
                  // {...form.getInputProps("thumnail")}
                  // onChange={(file) => handleChangeImage(file, "thumnail")}
                  // value={selectedImgUrl}
                  onChange={handleImgUrlChange}
                />
                {form.values.thumnail && (
                  <Text size="xs" mt={4} c="dimmed">
                    {form.values.thumnail.split("/").pop()}
                  </Text>
                )}
                <Box
                  mt="sm"
                  style={{
                    border: "2px dashed #e9ecef",
                    borderRadius: "8px",
                    padding: "12px",
                    backgroundColor: "#f8f9fa",
                    textAlign: "center",
                  }}
                >
                  <Text size="xs" c="dimmed" mb="xs">
                    Ảnh thu nhỏ hiện tại
                  </Text>
                  <Box
                    style={{
                      borderRadius: "6px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      border: "1px solid #dee2e6",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: 140,
                    }}
                  >
                    {form.getValues().thumnail ? (
                      <img
                        src={convertImageDomain(
                          form.getValues().thumnail?.toString() || ""
                        )}
                        alt="Preview Icon"
                        style={{
                          width: 120,
                          height: 120,
                          minWidth: 120,
                          minHeight: 120,
                          objectFit: "cover",
                          display: "block",
                          margin: "auto",
                          cursor: "pointer",
                        }}
                        onDoubleClick={() => {
                          setModalImageUrl(
                            form.getValues().thumnail?.toString() || ""
                          );
                          setZoomLevel(1);
                          setModalOpened(true);
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 120,
                          height: 120,
                          minWidth: 120,
                          minHeight: 120,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#f1f3f4",
                          color: "#6c757d",
                          fontSize: "12px",
                        }}
                      >
                        Chưa có ảnh
                      </div>
                    )}
                  </Box>
                </Box>
              </Box>
            </Grid.Col>
          </Grid>
        </>

        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <ButtonClose />
        </Group>
      </Box>
      <Modal
        opened={modalOpened}
        onClose={() => {
          setModalOpened(false);
          setZoomLevel(1);
        }}
        centered
        size="xl"
        title={
          <Group justify="space-between" style={{ width: "100%" }}>
            <Text fw={600}>Xem chi tiết ảnh</Text>
            <Group gap="xs">
              <Button
                variant="light"
                size="xs"
                leftSection={<IconMinus size={14} />}
                onClick={() =>
                  setZoomLevel((prev) => Math.max(0.25, prev - 0.25))
                }
                disabled={zoomLevel <= 0.25}
              >
                Zoom Out
              </Button>
              <Text size="sm" style={{ minWidth: "60px", textAlign: "center" }}>
                {Math.round(zoomLevel * 100)}%
              </Text>
              <Button
                variant="light"
                size="xs"
                leftSection={<IconPlus size={14} />}
                onClick={() => setZoomLevel((prev) => Math.min(3, prev + 0.25))}
                disabled={zoomLevel >= 3}
              >
                Zoom In
              </Button>
              <Button
                variant="light"
                size="xs"
                leftSection={<IconRotateClockwise size={14} />}
                onClick={() => setZoomLevel(1)}
              >
                Reset
              </Button>
            </Group>
          </Group>
        }
        overlayProps={{ zIndex: 999999 }}
        zIndex={999999}
        styles={{
          body: {
            padding: 0,
            overflow: "auto",
            maxHeight: "80vh",
          },
        }}
        style={{
          maxWidth: "95vw",
          maxHeight: "95vh",
        }}
      >
        {modalImageUrl && (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              overflow: "auto",
              backgroundColor: "#f8f9fa",
            }}
          >
            <img
              src={modalImageUrl}
              alt="Ảnh chi tiết"
              style={{
                transform: `scale(${zoomLevel})`,
                transformOrigin: "center",
                transition: "transform 0.2s ease-in-out",
                maxWidth: "none",
                maxHeight: "none",
                display: "block",
                cursor: zoomLevel < 3 ? "zoom-in" : "zoom-out",
              }}
              onClick={() => {
                if (zoomLevel < 3) {
                  setZoomLevel((prev) => Math.min(3, prev + 0.25));
                } else {
                  setZoomLevel(1);
                }
              }}
            />
          </Box>
        )}
      </Modal>
    </>
  );
};

export default EditView;
